<template>
  <v-text-field
    :label="field.label"
    :value="value"
    :disabled="field.disabled"
    v-model="$parent.entity[field.name]"
    :rules="validators()"
    :error-messages="errors"
    @change="onChange"
    :prepend-inner-icon="prependIcon"
  ></v-text-field>
</template>

<script>
import validators_mixin from "./../../mixins/validators.mixin";
export default {
  name: "StringField",
  props: ["field", "value"],
  mixins: [validators_mixin],
  computed: {
    prependIcon() {
      if (this.field.translatable) return "language";
      return "";
    }
  }
};
</script>

<style scoped></style>
